import {request, serviceUrl} from "@/utils/request";

//获取型号操控
export function listByModelIdAndDeviceId(modelId, deviceId) {
    return request({
        params: {
            modelId, deviceId
        },
        url: serviceUrl.deviceService + '/device/model-control/listByModelIdAndDeviceId'
    })
}


// 根据设备型号标识及测点类型获取操控
export function getByModelIdAndCode(modelId,code) {
    return request({
        url: serviceUrl.deviceService + '/device/model-control/getByModelIdAndCode',
        params: {modelId,code}
    })
}

// 根据设备型号标识及测点类型获取操控
export function getByDeviceIdAndPointId(deviceId,pointId) {
    return request({
        url: serviceUrl.deviceService + '/device/model-control/getByDeviceIdAndPointId',
        params: {deviceId,pointId}
    })
}